<template>
    <div>
        <p class="font-weight-bold d-block text-nowrap m-0">{{ get(permission, "['content_type']['name']")}}</p>
        <small class="text-muted">{{ actionResolver(permission['codename'].split("_")[0])}}</small>
    </div>
</template>

<script>

    import get from 'lodash.get'
    import usePermission from '../usePermission'


    export default {

        props: {
          permission: {
              type: Object,
              required: true
          }
        },

        setup() {

            const { actionResolver } = usePermission()

            return {
                actionResolver,
                get
            }
        }
    }
</script>
